import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditPickupRequest from "../Pages/InternationalPickupRequest/EditPickupRequest";
import PickupRequestList from "../Pages/InternationalPickupRequest/PickupRequestList";
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import CreatePickupRequest from "../Pages/InternationalPickupRequest/CreatePickupRequest";
import PickupNoteList from "../Pages/PickupNotes/PickupNoteList";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                allowedPermissions={["can_view_pickup_request"]}
                renderNoAccess={<PermissionRequired />}
              >
                <PickupRequestList />
              </AccessControl>
            }
          />
          <Route
            path="/create"
            element={
              <AccessControl
                allowedPermissions={["can_view_pickup_request"]}
                renderNoAccess={<PermissionRequired />}
              >
                <CreatePickupRequest />
              </AccessControl>
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                allowedPermissions={["can_view_pickup_request"]}
                renderNoAccess={<PermissionRequired />}
              >
                <EditPickupRequest />
              </AccessControl>
            }
          />
          <Route
            path="/pickup-note"
            element={
              <AccessControl
                allowedPermissions={["can_view_pickup_request"]}
                renderNoAccess={<PermissionRequired />}
              >
                <PickupNoteList />
              </AccessControl>
            }
          />
          {/* <Route
            path="/pickup-note/create"
            element={
              <AccessControl
                allowedPermissions={["can_create_pickup_note"]}
                renderNoAccess={<PermissionRequired />}
              >
                <CreatePickupNote />
              </AccessControl>
            }
          /> */}
          {/* <Route
            path="/pickup-note/edit/:id"
            element={
              <AccessControl
                allowedPermissions={["can_edit_pickup_note"]}
                renderNoAccess={<PermissionRequired />}
              >
                <EditPickupNote />
              </AccessControl>
            }
          /> */}
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
